<template>
    
    <Card class="w-full">
        <template #title>
            Acesso ao sistema
        </template>
        <template #content>
            <form @submit.prevent="login(form)">
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="login" v-model="form.login" class="w-full" />
                        <label for="login">Login</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['login'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <Password id="senha" v-model="form.senha" class="w-full" inputClass="w-full" :feedback="false" toggleMask />
                        <label for="senha">Senha</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['senha'] }}</div>
                </div>
                <div>
                    <RouterLink :to="{name: 'esqueci-senha'}">Esqueci minha senha</RouterLink>
                </div>
                <Button 
                    type="submit" 
                    label="Entrar" 
                    severity="warn"
                    icon="pi pi-check" 
                    class="w-full mt-4" 
                    :loading="isLoading" />
            </form>
        </template>
    </Card>
</template>

<script>
import Card from 'primevue/card';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';

import Auth from '@/service/auth.js';
import Token from '@/utils/Token.js';

export default {
    components: {
        Card,
        FloatLabel,
        InputText,
        Password,
        Button,
    },
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
        }
    },
    mounted() {
        if(this.$route.query.error == 'auth') {
            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: 'Você precisa se conectar para acessar a página.', life: 5000 });
        }
    },
    methods: {
        login(form) {
            this.errors = {};
            this.isLoading = true;

            Auth.login(form)
                .then(response => {
                    Token.set(response.data.token);
                    this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: `Seja bem vindo ${response.data.nome}!`, life: 3000 });
                    this.$router.push('/app/home');
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;
                        if(err.erros) {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if(error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>